const Wrap = ({ wrapper, children }) => wrapper(children)

export default Wrap
